import { useEffect, useState } from "react"
import { Alert, Grid, Stack, Typography } from "@mui/material"

import useInternalFetch from "../../api/apiInternal"
import useAuth 			from "../../hooks/useAuth"
import CardFilter 		from "./components/CardFilter"
import CardCreateFilter from "./components/CardCreateFilter"
import Loading 			from "../../components/Loading"
import config 			from "../../common/Config"

const PanelFilterList = () => {

	const internalFetch							= useInternalFetch()

	const {auth}								= useAuth()

	const [userScreeners, setUserScreeners]		= useState()
	const [publicScreeners, setPublicScreeners]	= useState()
	const [isLoading, setIsLoading]				= useState(true)
	const [returnMessage, setReturnMessage]		= useState()

	useEffect(() => {
		loadScreeners()
	}, [])

	const handleDelete = (e) => {
		if (!e) {
			setReturnMessage({severity : 'success', message : 'Filtro removido com sucesso!'})
		}
		else {
			setReturnMessage({severity : 'error', message: 'Erro ao remover filtro!'})
		}

		loadScreeners()
	}

	const loadScreeners = () => {
		internalFetch(config.apiUrl +'/api/screener')
		.then(result => {
			if (!result.status) {
				setUserScreeners(result.filter(r => r.userId === auth.userId))
				setPublicScreeners(result.filter(r => r.userId === null))
				setIsLoading(false)
			}
		})
	}

	if (isLoading) return <Loading/>

	return (
		<Stack direction={'column'} width={'100%'}>

			{returnMessage ? <Alert severity={returnMessage.severity} onClose={() => setReturnMessage()}>{returnMessage.message}</Alert> : null }
			<Typography variant="h5" width={'98%'} alignSelf={"start"} marginLeft={1} padding={1} borderBottom={1}>Filtros</Typography>				

			<Grid container marginTop={1} spacing={1} padding={1}>
				{Array.isArray(userScreeners) && (userScreeners.length === 0 || auth.userId === 1) && (
					<Grid item xs={12} lg={4}><CardCreateFilter title="Criar Novo Filtro" subtitle={"Filtros de "+ auth.user}/></Grid>
				)}
				
				{userScreeners.map(us => (
					<Grid item xs={12} lg={4}>
						<CardFilter id={us.id} title={us.title} subtitle={"Filtros de "+ auth.user} onDelete={handleDelete}/>
					</Grid>
				))}

				{ publicScreeners && publicScreeners.map(ps => (
					<Grid item xs={12} lg={4}><CardFilter id={ps.id} title={ps.title} subtitle={ps.caption || "-"} onDelete={auth.userId == 1 ? handleDelete : null}/></Grid>
				))}
			</Grid>
		</Stack>
	)
}

export default PanelFilterList
